














































import { Vue, Component, Provide } from "vue-property-decorator";
import { Contexts } from "@/models/contexts";
import { GrantTypes } from "@/data/enums/tokens";

@Component
export default class Login extends Vue {
  @Provide() private email = "";
  @Provide() private password = "";
  private isProcessing = false;

  public get formIsValid() {
    if (!this.email) return false;
    if (!this.password) return false;
    return true;
  }

  public loginWithPassword() {
    this.isProcessing = true;
    this.$store
      .dispatch("auth/login", {
        context: Contexts.ADMIN,
        payload: {
          grant_type: GrantTypes.ADMIN,
          password: this.password,
          username: this.email
        }
      })
      .catch(error => {
        this.isProcessing = false;
        if (error !== "cancelled") {
          this.$buefy.toast.open({
            type: "is-danger",
            message: this.$_.get(
              error,
              "response.data.error.message",
              this.$t("_sentence.something_went_wrong")
            )
          });
        }
      });
  }
}
